import styled from 'styled-components';

type TestCaseBoxProps = {
  expanded: boolean;
};
export const TestCaseBoxStyled = styled.div<TestCaseBoxProps>`
  ${(props) =>
    !props.expanded &&
    `
      &:hover {
          background-color: var(--ds-surface-hovered, var(--ds-fb-surface-hovered));
        }
    `}
  box-shadow: var(--ds-shadow-overlay, var(--ds-fb-shadow-overlay));
  border-color: var(--ds-border-disabled, var(--ds-fb-border-disabled));
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  margin-bottom: 8px;
  margin-left: 5px;
  margin-right: 5px;
`;
